








import Vue, { PropType } from "vue";
import AufstellungHeaderComp from "./AufstellungHeaderComp.vue";
import AufstellungBodyComp from "./AufstellungBodyComp.vue";
import MenuAufstellungenComp from "./MenuAufstellungenComp.vue";
import { Encounter } from "models/Encounter";
import { Aufstellung } from "models/Aufstellung";

export default Vue.extend({
	name: "AufstellungComp",
	components: { MenuAufstellungenComp, AufstellungBodyComp, AufstellungHeaderComp },
	props: {
		aufstellung: Object as PropType<Aufstellung & Encounter>,
		showExtraRoles: Boolean,
	},
	data: () => ({
		copyActive: false,
	}),
	methods: {
		stopCopy: function(): void {
			this.copyActive = false;
		},
		toggleCopy: function(): void {
			this.copyActive = !this.copyActive;
		},
	},
});
